import { confirmable } from 'react-confirm';
import StackedModal from './stacked_modal';
import { useTranslation } from 'react-i18next';
import { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { Icon, TextField } from '@shopify/polaris';
import { BarcodeIcon } from '@shopify/polaris-icons';

function ScanSelectDialog({ show, proceed, title, placeholder, confirmText, onVerify }) {
  const { t } = useTranslation('common');
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [verifiedValue, setVerifiedValue] = useState('');

  const handleChange = useCallback((newValue) => {
    setInputValue(newValue);
    setError('');
    setSuccess(false);
    setSuccessMessage('');
    setVerifiedValue('');
  }, []);

  const handleVerify = useCallback(async () => {
    if (!inputValue.trim()) return;
    setError('');
    setSuccess(false);
    try {
      if (onVerify) {
        const result = await onVerify(inputValue.trim());
        if (result.success) {
          setSuccess(true);
          setSuccessMessage(result.message || '');
          setVerifiedValue(result.value || inputValue.trim());
        } else {
          setError(result.error || t('common:message.verification_failed'));
        }
      } else {
        setSuccess(true);
        setVerifiedValue(inputValue.trim());
      }
    } catch (err) {
      setError(err.message || t('common:message.verification_failed'));
    }
  }, [inputValue, onVerify, t]);

  return (
    <StackedModal
      isOpen={show}
      title={title}
      content={
        <Box
          display="flex"
          flexDirection="column"
          rowGap={0.5}
        >
          <div onKeyDown={(e) => e.key === 'Enter' && handleVerify()}>
            <TextField
              value={inputValue}
              onChange={handleChange}
              prefix={<Icon source={BarcodeIcon} />}
              autoComplete="off"
              focused={true}
              placeholder={placeholder}
              error={error}
            />
          </div>
          {success && successMessage && (
            <Box sx={{ color: '#17463A', fontSize: '0.8125rem' }}>{successMessage}</Box>
          )}
        </Box>
      }
      primaryAction={{
        content: confirmText || t('common:button.select'),
        disabled: !success,
        onAction: () => proceed({ confirmed: true, value: verifiedValue }),
      }}
      onClose={() => proceed({ confirmed: false, value: null })}
    />
  );
}

export default confirmable(ScanSelectDialog);
